import { render, staticRenderFns } from "./SocialGames.vue?vue&type=template&id=6374555c&scoped=true&lang=html&"
import script from "./SocialGames.vue?vue&type=script&lang=js&"
export * from "./SocialGames.vue?vue&type=script&lang=js&"
import style0 from "./SocialGames.vue?vue&type=style&index=0&id=6374555c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6374555c",
  null
  
)

component.options.__file = "SocialGames.vue"
export default component.exports